export default __webpack_public_path__ + "static/media/iceimg.9d460c7d.jpg";